import "../../node_modules/animate.css/animate.min.css"
import 'font-awesome/css/font-awesome.min.css';
import '../pages/css/pages-icons.css'
require('../../node_modules/bootstrap/dist/css/bootstrap.min.css');
require('../../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker3.css');
// require('../../node_modules/ng-table/dist/ng-table.min.css');
require('../../node_modules/sweetalert/dist/sweetalert.css');
require('../../node_modules/ui-select/dist/select.css');
